/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationCompanyMutation($input: SaveSimulationCompany_M_simulation_companyInput!) {
    saveSimulationCompany_M_simulation_company(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
